<template>
  <div class="formGroup">
    <div class="formGroup_main">
      <div class="row_justify_between">
        <div class="formGroup_title">{{ title }}</div>
        <div class="formGroup_right"><slot name="right"></slot></div>
      </div>
      <div class="formGroup_content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title"],
};
</script>

<style lang="scss" scoped>
.formGroup_main {
  max-width: 902px;
  padding: 0 16px;
  margin: 16px auto;
}
.formGroup_title {
  font-size: 18px;
  font-weight: 900;
  color: #5ba7ad;
  line-height: 28px;
  border-left: 4px solid #38959d;
  padding-left: 20px;
}
.formGroup_content {
  max-width: 867px;
  margin: auto;
}

@media screen and (max-width: 767px) {
  .formGroup_title {
    font-size: 18px;
    line-height: 24px;
  }
  .formGroup {
    .row_justify_between {
      flex-direction: column;
      align-items: flex-start;
    }
    .formGroup_right {
      margin-top: 10px;
    }
  }
}
</style>